export enum Size {
  xsmall = 'xsmall',
  small = 'small',
  xmedium = 'xmedium',
  medium = 'medium',
  large = 'large',
  xlarge = 'xlarge',
}
